module.exports = __webpack_public_path__ + "static/img/2-7-错发退货退款.1c42d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-7-错发退货退款.png
// module id = 1319
// module chunks = 0